import { forwardRef } from "react";
import { useSafeKeyDown } from "../utility/hook/useSafeKeyDown";
/***
 * ...rest (other props)
 * ***/
const SimpleRefInput = forwardRef(({
    disabled=false,
    type="text",
    handleKeyDown,
    ...rest
},ref)=>{
    
    const { onKeyDown, onCompositionStart, onCompositionEnd } =
    useSafeKeyDown(handleKeyDown);
    return (
        <input 
            disabled={disabled} 
            type={type}
            ref={ref} 
            onKeyDown={onKeyDown}
            onCompositionStart={onCompositionStart}
            onCompositionEnd={onCompositionEnd}
            {...rest}
            />
    )
    
});

export {SimpleRefInput}